import React from 'react';
import StatusBadge from './StatusBadge';

/**
 * NoteCard - Card for displaying meeting notes documents from Google Drive
 */
const NoteCard = ({
  note,
  isSelected,
  onClick,
  formatDate
}) => {
  // Format relative time for display
  const formatRelativeTime = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays === 0) {
      if (diffHours === 0) return `${diffMins}m ago`;
      return `${diffHours}h ago`;
    }
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    return formatDate ? formatDate(dateStr) : new Date(dateStr).toLocaleDateString();
  };

  // Extract a cleaner display title
  const getDisplayTitle = () => {
    const title = note.title || 'Meeting Notes';
    // Remove "Meeting notes - " prefix if present
    return title.replace(/^Meeting notes\s*[-–]\s*/i, '') || 'Meeting Notes';
  };

  return (
    <div
      className={`transcript-card note-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onClick(note)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => e.key === 'Enter' && onClick(note)}
      aria-label={`${note.title || 'Meeting Notes'}, ${formatRelativeTime(note.modified_time)}`}
    >
      {/* Header with badges */}
      <div className="transcript-card-header">
        <div className="transcript-card-badges">
          <StatusBadge variant="google" size="small">Google Docs</StatusBadge>
          {note.meeting_code && (
            <StatusBadge variant="neutral" size="small">{note.meeting_code}</StatusBadge>
          )}
        </div>

        <div className="transcript-card-actions">
          <a
            href={note.doc_url}
            target="_blank"
            rel="noopener noreferrer"
            className="transcript-regenerate-btn"
            title="Open in Google Docs"
            aria-label="Open in Google Docs"
            onClick={(e) => e.stopPropagation()}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </div>
      </div>

      {/* Title */}
      <div className="transcript-card-title">
        {getDisplayTitle()}
      </div>

      {/* Meta row */}
      <div className="transcript-card-meta">
        <span className="transcript-date" title={formatDate ? formatDate(note.modified_time) : note.modified_time}>
          {formatRelativeTime(note.modified_time)}
        </span>
        {note.meeting_code && (
          <>
            <span className="meta-separator">•</span>
            <span className="meeting-code-hint">
              {note.meeting_code}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default NoteCard;
